import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
/**
 * The minimum details for a translation. Typically translationSchema is what
 * should be used, but this schema exists for supporting translations from POT
 * files.
 */
export const baseTranslationSchema = z.object({
    english: z.string().describe(createCustomSettings({
        label: "English",
        isTextArea: true,
    })),
    french: z.string().describe(createCustomSettings({
        label: "French",
        isTextArea: true,
    })),
    user_id: z.string().describe(createCustomSettings({
        hide: true,
    })),
});
export const translationCreationSchema = baseTranslationSchema.extend({
    notes: z
        .string()
        .default("")
        .describe(createCustomSettings({
        label: "Notes",
        isTextArea: true,
    })),
    links: z
        .string()
        .default("")
        .describe(createCustomSettings({
        label: "Links",
        isTextArea: true,
    })),
});
export const translationSchema = translationCreationSchema.extend({
    id: z.number().describe(createCustomSettings({
        hide: true,
    })),
    added: z.string().describe(createCustomSettings({
        hide: true,
    })),
    position: z.string().describe(createCustomSettings({
        hide: true,
    })),
    deleted: z.string().describe(createCustomSettings({
        hide: true,
    })),
    string_id: z.string().describe(createCustomSettings({
        hide: true,
    })),
    urls: z.string().describe(createCustomSettings({
        hide: true,
    })),
});
//# sourceMappingURL=types.js.map